import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructDelete } from '../../../types/ConstructDelete';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const deleteApplicationDoc = async (
  constructDelete: ConstructDelete,
  uuid: string,
  docId: string,
  definitionName: string,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructDelete(
    `${APPLICATION_BASE_PATH}/${uuid}/docs/${docId}`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.RelatedDefinitionName]: 'doc',
      },
    },
    { preventDefaultErrorToast: true },
  );
